import { render, staticRenderFns } from "./amsInfoAi.vue?vue&type=template&id=beb460ac&"
import script from "./amsInfoAi.vue?vue&type=script&lang=js&"
export * from "./amsInfoAi.vue?vue&type=script&lang=js&"
import style0 from "./amsInfoAi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb460ac')) {
      api.createRecord('beb460ac', component.options)
    } else {
      api.reload('beb460ac', component.options)
    }
    module.hot.accept("./amsInfoAi.vue?vue&type=template&id=beb460ac&", function () {
      api.rerender('beb460ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/ams/amsInfoAi.vue"
export default component.exports